import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {TimeagoModule} from 'ngx-timeago';
import {RouterModule} from '@angular/router';
import {SWIPER_CONFIG, SwiperConfigInterface, SwiperModule} from 'ngx-swiper-wrapper';
import {EndUserPricePlanCardComponent} from './end-user-price-plan-card/end-user-price-plan-card.component';
import {SingleUnitLogComponent} from './single-unit-log/single-unit-log.component';
import {GridModule} from 'gelios-ng-admin-components';
import {GeliosFieldModule} from '../../lib/gelios-field/gelios-field.module';
import {UnitCardComponent} from './unit-card.component';
import {QRCodeModule} from 'angularx-qrcode';
import {UnitCommandListComponent} from './unit-command-list/unit-command-list.component';
import {LocatorCreateComponent} from './locator-create/locator-create.component';
import {ClipboardModule} from 'ngx-clipboard';
import {UnitLastOrderComponent} from './unit-last-order/unit-last-order.component';
import {UnitLastOrderImagesComponent} from './unit-last-order-images/unit-last-order-images.component';
import {BaseUnitViewLogComponent} from '../unit/view-log/base-unit-view-log.component';
import {UnitPricePlansComponent} from './unit-price-plans/unit-price-plans.component';
import {UnitEndUserInfoComponent} from './unit-end-user-info/unit-end-user-info.component';
import {UnitLastOrderInfoComponent} from './unit-last-order/unit-last-order-info.component';
import {OrderStatusComponent} from './order-status/order-status.component';
import {UnitInfoComponent} from './unit-info/unit-info.component';
import {UnitGeneralInfoComponent} from './unit-general-info/unit-general-info.component';
import {UnitBatteryComponent} from './unit-battery/unit-battery.component';
import {UnitCarIndicatorsComponent} from './unit-car-indicators/unit-car-indicators.component';
import {ChargingStationIndicatorsComponent} from './charging-station-indicators/charging-station-indicators.component';
import {UnitPrepaidSharingPricePlansComponent} from './unit-prepaid-sharing-price-plans/unit-prepaid-sharing-price-plans.component';
import {PrepaidSharingPricePlanCardComponent} from './prepaid-sharing-price-plan-card/prepaid-sharing-price-plan-card.component';
import {UnitDemandComponent} from './unit-demand/unit-demand.component';
import {UnitDemandInfoComponent} from './unit-demand-info/unit-demand-info.component';
import {UnitWriteOffFormComponent} from './unit-write-off/unit-write-off-form/unit-write-off-form.component';
import {UnitWriteOffInfoComponent} from './unit-write-off/unit-write-off-info/unit-write-off-info.component';
import {UnitGroupsComponent} from './unit-groups/unit-groups.component';
import {UnitGroupItemComponent} from './unit-groups/unit-group-item/unit-group-item.component';
import {AddUnitToGroupComponent} from './unit-groups/add-unit-to-group/add-unit-to-group.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    UnitCardComponent,
    EndUserPricePlanCardComponent,
    PrepaidSharingPricePlanCardComponent,
    SingleUnitLogComponent,
    BaseUnitViewLogComponent,
    UnitCommandListComponent,
    LocatorCreateComponent,
    UnitLastOrderComponent,
    UnitLastOrderImagesComponent,
    UnitPricePlansComponent,
    UnitPrepaidSharingPricePlansComponent,
    UnitEndUserInfoComponent,
    UnitLastOrderInfoComponent,
    OrderStatusComponent,
    UnitInfoComponent,
    UnitGeneralInfoComponent,
    UnitBatteryComponent,
    UnitCarIndicatorsComponent,
    ChargingStationIndicatorsComponent,
    UnitDemandComponent,
    UnitDemandInfoComponent,
    UnitWriteOffFormComponent,
    UnitWriteOffInfoComponent,
    UnitGroupsComponent,
    UnitGroupItemComponent,
    AddUnitToGroupComponent
  ],
  exports: [
    UnitCardComponent,
    SingleUnitLogComponent,
    BaseUnitViewLogComponent,
    UnitCommandListComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TimeagoModule,
    LeafletModule,
    RouterModule,
    SwiperModule,
    GridModule,
    GeliosFieldModule,
    QRCodeModule,
    ClipboardModule,
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
})
export class UnitCardModule {
}
